export default __webpack_public_path__ + "static/media/Red0005.d5f342e3.png";